import React from 'react';
/**
 * Recursively searches for a child component by its 'name' prop.
 *
 * @param {React.ReactNode} children - The children to search through.
 * @param {string} name - The name prop to match.
 * @returns {React.ReactNode|null} The found child or null if not found.
 */
export const findChildByName = (children, name) => {
    let found = null;
    React.Children.forEach(children, (child) => {
        if (found || !child) {
            return;
        }
        if (child.props && child.props.name === name) {
            found = child;
        } else if (child.props && child.props.children) {
            found = findChildByName(child.props.children, name) || found;
        }
    });
    return found;
};
